import React from 'react';
import { Alert, AlertProps, Stack, Typography } from '@mui/material';
import { Warning } from '@mui/icons-material';

interface Props extends AlertProps {
    errorMessages: CVT.Maybe<string>[];
    centered?: boolean;
    title?: string;
}

export const ErrorsAlert: React.FC<Props> = (props) => {
  const { errorMessages, title, centered = false, ...alertProps } = props;

  return (
    <Alert
      severity="error"
      icon={<Warning/>}
      {...alertProps}
    >
      <Stack justifyContent={centered ? 'center' : undefined}>
        {!!title && (
          <Typography fontSize={12} mb={1}>
            {title}
          </Typography>
        )}

        {errorMessages.map((message, index) => message && (
          <Typography fontSize={12} key={index} component={message.includes('\n') ? 'pre' : 'p'}>
            {message}
          </Typography>
        ))}
      </Stack>
    </Alert>
  );
};
